'use strict';

require('../../../modules/es.array.find');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');
module.exports = getBuiltInPrototypeMethod('Array', 'find');